import React, { useEffect, useRef, useState } from 'react';
import StickyTable from '../../../../components/table/stickyTable/StickyTable';
import columnHistory from './columnHistory';
import { callApiWithoutDispatch } from '../../../../utils/apiUtils';
import {
  onBoardingExportFleetTransactionsApi,
  onBoardingGetFleetTransactionsApi,
} from '../../../../constants/ApiConfigs';
import { Button } from 'react-bootstrap';
import CCDropDown from '../../../../components/dropdown/ccDropDown';
import { I18n } from 'react-redux-i18n';
import { FaDownload } from 'react-icons/fa';
import { MdFilterList } from 'react-icons/md';
import { FiDownload } from 'react-icons/fi';
import { handleValueAmount } from '../billingOverview/component/TransactionHistory';
import ExportComponent from '../../../../components/ExportComponent';
import { exportFleetTransactionsToExcel } from '../../../../actions/driverAction';
import { TAB_LIST } from '../../BillingUsage';

export const TRANSACTION_TYPE_BILLING = {
  all: 'all',
  booking: 'booking',
  addOn: 'addOn',
  systemTopUp: 'systemTopUp',
  autoTopUp: 'autoTopUp',
  manualTopUp: 'manualTopUp',
  bookingDeduct: 'bookingDeduct',
  bookingEarning: 'bookingEarning',
  cancellationPenalty: 'cancellationPenalty',
  noShowPenalty: 'noShowPenalty',
  withdraw: 'withdraw',
  gsnManualTopUp: 'gsnManualTopUp',
  gsnSystemTopUp: 'gsnSystemTopUp',
};

const BillingTransactionHistory = ({
  loadingActions,
  notification,
  tabActive,
  ...props
}) => {
  const toobarContainerRef = useRef();
  const parentRef = useRef();
  const toolbarExtendRef = useRef();
  const [bodyData, setBodyData] = useState([]);
  const [transactionType, setTransactionType] = useState('all');
  const [footerData, setFooterData] = useState({
    limit: 20,
    total: 0,
    page: 0,
  });
  useEffect(() => {
    if (tabActive === TAB_LIST.transactionHistory) {
      getBodyData();
    }
  }, [tabActive]);

  const getOptionTransactionType = () => {
    return Object.values(TRANSACTION_TYPE_BILLING)
      ?.filter(
        (item) =>
          ![
            TRANSACTION_TYPE_BILLING.gsnManualTopUp,
            TRANSACTION_TYPE_BILLING.gsnSystemTopUp,
          ].includes(item),
      )
      .map((item) => ({
        label: I18n.t(`billingUsage.${item}`),
        value: item,
      }));
  };

  const getDateRangeForPast12Months = () => {
    const today = new Date();
    const toDate = `${today.getFullYear()}-${String(
      today.getMonth() + 1,
    ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    const fromDateObj = new Date(today);
    fromDateObj.setMonth(fromDateObj.getMonth() - 12);
    const fromDate = `${fromDateObj.getFullYear()}-${String(
      fromDateObj.getMonth() + 1,
    ).padStart(2, '0')}-${String(fromDateObj.getDate()).padStart(2, '0')}`;
    return { fromDate, toDate };
  };

  const getBodyData = async (activePage, limit) => {
    limit = limit ? limit : footerData.limit || 20;
    activePage = activePage ? activePage : 0;
    const { fromDate, toDate } = getDateRangeForPast12Months();
    loadingActions.showLoadingSpiner();
    try {
      const response = await callApiWithoutDispatch(
        onBoardingGetFleetTransactionsApi,
        {
          method: 'POST',
          body: JSON.stringify({
            criteria: {
              serviceType: 'all',
              transactionType,
              fleetId: props.auth?.selectedFleet?.fleetId,
              toDate: toDate,
              fromDate: fromDate,
            },
            size: limit,
            from: activePage * limit,
            fleetId: props.auth?.selectedFleet?.fleetId,
            _currentFleetId: props.auth?.selectedFleet?.fleetId,
          }),
        },
      );
      if (response?.res?.list?.length > 0) {
        setBodyData(response.res.list);
        let { size, total } = response.res || {};
        setFooterData({
          ...footerData,
          total,
          limit,
          page: activePage,
        });
      } else {
        setBodyData([]);
        setFooterData({
          ...footerData,
          total: 0,
        });
      }
    } catch (error) {
    } finally {
      loadingActions.hideLoadingSpiner();
    }
  };
  const getTableColumns = () => {
    let tableColums = Object.assign([], columnHistory);

    _.forEach(tableColums, (col, index) => {
      switch (col.key) {
        case 'amount':
          col.customCell = (data) => {
            return handleValueAmount(data, props?.billingUsage?.currencyISO);
          };
          break;
        case 'transactionType':
          col.customCell = (data) => {
            return I18n.t(`billingUsage.${data.transactionType}`);
          };
          break;
      }
    });

    return tableColums;
  };

  const handleNumItemsPerPageChange = (limit) => {
    getBodyData(0, limit);
  };

  const handlePaginationSelect = (page) => {
    getBodyData(page, footerData.limit);
  };

  const getTableHeight = () => {
    const verticalPadding = 50;
    const toolbarheight = toobarContainerRef?.current?.offsetHeight || 0;
    const toolbarExtendHeight = toolbarExtendRef?.current?.offsetHeight || 0;
    const parentHeight = parentRef?.current?.offsetHeight || 0;
    const outerHeight = verticalPadding + toolbarheight + toolbarExtendHeight;
    let tableHeight = parentHeight ? parentHeight - outerHeight : 0;
    if (window.innerHeight < 850 && tableHeight < 500) tableHeight = 550;
    return tableHeight;
  };

  const prepareParamExport = () => {
    const { fromDate, toDate } = getDateRangeForPast12Months();
    const query = {
      criteria: {
        serviceType: 'all',
        fleetId: props.auth?.selectedFleet?.fleetId,
      },
      billingUsageType: transactionType,
      fleetBillingCurrency: props.billingUsage?.currencyISO,
      toDate: toDate,
      fromDate: fromDate,
      size: footerData.limit,
      from: footerData.page * footerData.limit,
      fleetId: props.auth?.selectedFleet?.fleetId,
      userId: props.auth?.user?._id,
    };
    return { query };
  };

  return (
    <>
      <div className="billing-transaction-history-container" ref={parentRef}>
        <div className="tabActions-view" ref={toolbarExtendRef}>
          <p>{I18n.t('billingUsage.showingTransactionsPast12Months')}</p>
          <div>
            <Button
              variant="link"
              size="sm"
              className="btn-header text-add-header"
              onClick={() => getBodyData()}
            >
              {' '}
              <MdFilterList /> {I18n.t('billingUsage.filter')}
            </Button>
            <ExportComponent
              prepareParamExport={prepareParamExport}
              title={
                <span>
                  <FiDownload /> {I18n.t('billingUsage.export')}
                </span>
              }
              urlExport={async (body) => {
                return await callApiWithoutDispatch(
                  onBoardingExportFleetTransactionsApi,
                  {
                    method: 'POST',
                    body: JSON.stringify({
                      ...body,
                      fleetId: props.auth?.selectedFleet?.fleetId,
                    }),
                  },
                );
              }}
              user={props.auth?.user}
            />
          </div>
        </div>
        <div className="tabActions" ref={toobarContainerRef}>
          <CCDropDown
            id="booking-type-dropdown"
            items={getOptionTransactionType()}
            title={I18n.t('cue.networkType')}
            selectedItems={[transactionType]}
            valueKey="value"
            labelKey="label"
            onSelect={(value) => setTransactionType(value)}
          />
        </div>
        <StickyTable
          columns={getTableColumns()}
          bodyData={bodyData}
          footerData={footerData}
          rowHeight={50}
          getTableHeight={getTableHeight}
          handleNumItemsPerPageChange={handleNumItemsPerPageChange}
          handlePaginationSelect={handlePaginationSelect}
          notCheckShouldComponentUpdate={true}
        />
      </div>
    </>
  );
};

export default BillingTransactionHistory;
